// VIDEO IFRAME
function playVideo(button) {
  const coverContainer = button.closest(".cover-container");
  const videoContainer = coverContainer.nextElementSibling;

  // Hide cover image and button
  coverContainer.style.display = "none";

  // Show the video container
  videoContainer.style.display = "block";

  // Autoplay the video
  const iframe = videoContainer.querySelector("iframe");
  const videoSrc = iframe.getAttribute("src");
  iframe.setAttribute(
    "src",
    videoSrc + (videoSrc.includes("?") ? "&" : "?") + "autoplay=1"
  );
}

// SELF HOSTED VIDEO
// Good
document.addEventListener("DOMContentLoaded", function () {
  // Set video controls to false
  var vids = document.querySelectorAll("video");
  vids.forEach(function (vid) {
    vid.controls = false;
  });

  // Handle video visibility and autoplay based on intersection
  var videos = document.querySelectorAll(".nectar-video-self-hosted");
  var observerOptions = {
    root: null,
    rootMargin: "150px",
    threshold: 0.5,
  };

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.style.visibility = "visible";
        var playPromise = entry.target.play();
        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              // Hide the play button and background image
              var nectarWrapper = entry.target.closest(".nectar_wrapper");
              var playButton = nectarWrapper.querySelector(".play-button");
              var nectarVideoWrapper = nectarWrapper.querySelector(
                ".nectar_video_wrapper"
              );

              playButton.style.display = "none";
              nectarVideoWrapper.style.backgroundImage = "none";
            })
            .catch(() => {
              // Autoplay failed, mute video and try to play again
              entry.target.muted = true;
              entry.target
                .play()
                .then(() => {
                  var nectarWrapper = entry.target.closest(".nectar_wrapper");
                  var playButton = nectarWrapper.querySelector(".play-button");
                  var nectarVideoWrapper = nectarWrapper.querySelector(
                    ".nectar_video_wrapper"
                  );

                  playButton.style.display = "none";
                  nectarVideoWrapper.style.backgroundImage = "none";
                })
                .catch((error) => {
                  console.log("Autoplay failed again: ", error);
                  // Show the play button if autoplay fails
                  var button = entry.target
                    .closest(".nectar_wrapper")
                    .querySelector(".play-button");
                  button.style.display = "block";
                });
            });
        }
      } else {
        entry.target.pause();
        entry.target.style.visibility = "hidden";
      }
    });
  }, observerOptions);

  videos.forEach(function (video) {
    observer.observe(video);
  });

  // Play video on button click
  window.playSelfHostedVideo = function (button) {
    console.log("Button clicked");
    var nectarWrapper = button.closest(".nectar_wrapper");
    var video = nectarWrapper.querySelector(".nectar-video-self-hosted");

    if (video) {
      console.log("Video found");
      video.style.visibility = "visible";
      button.style.display = "none";
      nectarWrapper.querySelector(
        ".nectar_video_wrapper"
      ).style.backgroundImage = "none";

      video
        .play()
        .then(() => {
          console.log("Video is playing");
        })
        .catch((error) => {
          console.log("Play button error: ", error);
          // Mute video and try to play again
          video.muted = true;
          video
            .play()
            .then(() => {
              console.log("Video is playing with sound muted");
            })
            .catch((error) => {
              console.log("Play button error again: ", error);
            });
        });
    } else {
      console.log("Video not found");
    }
  };
});
